<!-- commenting out for now -->
<!-- <div #vl [style.height]="height ? height + 'px' : ''" class="absolute vl bl medium-gray"></div> -->
<ng-content></ng-content>
